// this code was coped from js-utils/janus to handle the cityBrowse event clicked, which will log the event_id in addition the check points.

import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import map from 'lodash/map';
import Cookies from 'cookies-js';

import { logCheckpointViaAjax } from '@eb/janus';
import { HAS_WINDOW } from 'eventbrite_design_system/utils/dom';

const getWindowObject = (key) => HAS_WINDOW && window[key];

const CHECKPOINT_COOKIE_NAME = 'janus_cp';
const EVENT_ID = 'event_id';
const CHECK_POINT = 'check_point';
const EXPIRATION_MINUTES = 5;

const _isCachedHit = () => {
    const isVarnishHit = getWindowObject('eb') && getWindowObject('eb').VHit;

    return !isUndefined(isVarnishHit) && !isNull(isVarnishHit);
};

const _formatCheckpointNamesV2 = (checkpointNames) =>
    map(checkpointNames.split(','), (name) => `${CHECK_POINT}=${name}`).join(
        '&',
    );

const _getCookieProperties = (domain) => {
    const expirationDate = new Date();

    expirationDate.setMinutes(expirationDate.getMinutes() + EXPIRATION_MINUTES);

    return {
        expires: expirationDate,
        domain: domain.charAt(0) !== '.' ? `.${domain}` : domain,
        path: '/',
    };
};

/**
 * Set a cookie to request that the event_id be logged.
 *
 * Janus middleware looks for this cookie on the next request, and
 * logs a event_id
 *
 * @param {string} eid event_id of the event the user clicks on
 * @param  {string} domain domain name
 */
const _setRequestCheckpointEidCookie = (checkpointNames, domain, eid) => {
    const cookieProperties = _getCookieProperties(domain);
    const formattedcheckpointNames = _formatCheckpointNamesV2(checkpointNames);
    const cookieStr = `v=2&${formattedcheckpointNames}&${EVENT_ID}=${eid}`;

    Cookies.set(CHECKPOINT_COOKIE_NAME, cookieStr, cookieProperties);
};

/**
 * Logs a checkpoint and event_id when a user navigates to the next page.
 *
 * @param {string} checkpointNames comma-separated list of checkpoint names to log
 * @param  {string} domain domain name
 * @param {string} eid event_id to log
 */
export const logCheckpointEidOnPageChange = (checkpointNames, domain, eid) => {
    if (_isCachedHit()) {
        return;
    }
    _setRequestCheckpointEidCookie(checkpointNames, domain, eid);
};

/**
 * Logs page viewed checkpoint for destination_search_viewed_3p
 *
 * @param {bool} shouldLogManualEvent Boolean determining if the content contains
 * a third party event
 */
export const logManualEventCheckpoint = (shouldLogManualEvent) => {
    if (shouldLogManualEvent) {
        logCheckpointViaAjax('destination_search_viewed_3p');
    }
};

/**
 * Logs page viewed checkpoint for destination_search_viewed
 */
export const logSearchPageViewCheckpoints = () => {
    logCheckpointViaAjax('destination_search_viewed');
};
